import React, { ReactNode } from 'react'
import clsx from 'clsx'
import makeStyles from '@mui/styles/makeStyles'
import { Drawer, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { AdminDrawerList } from './components/AdminDrawerList/AdminDrawerList'
import { ProfileDrawerList } from './components/ProfileDrawerList/ProfileDrawerList'
import { GameDrawerList } from './components/GameDrawerList/GameDrawerList'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      width: 250,
    },
    fullList: {
      width: 'auto',
    },
    dividerFullWidth: {
      margin: `5px 0 0 ${theme.spacing(2)}`,
    },
  })
)

interface Props {
  children: (openDrawer: () => void) => ReactNode
}

export const NavbarDrawer: React.FC<Props> = ({ children }) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)

  const list = (
    <div className={clsx(classes.list)} role="presentation" onClick={() => setOpen(true)}>
      <AdminDrawerList />
      <GameDrawerList />
      <ProfileDrawerList />
    </div>
  )

  return (
    <div>
      {children(() => setOpen(true))}
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        {list}
      </Drawer>
    </div>
  )
}
